module.exports = __webpack_public_path__ + "img/art-branding.d556f6fc.png";